module.exports = __webpack_public_path__ + "static/34invgde-ab04da1c2dd47903d6b085fe11f1adb4.gif";